var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 118,
    viewBox: "0 0 330 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 118H330V31.2202C330 22.3836 322.837 15.2202 314 15.2202H120.958C117.999 15.2202 115.098 14.3996 112.577 12.8496L95.5358 2.37057C93.0152 0.820596 90.1141 0 87.155 0H16C7.16344 0 0 7.16345 0 16V118Z",
    fill: "#000514",
    fillOpacity: 0.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderback);
export default __webpack_public_path__ + "static/media/folderback.e12495ef8452814a162d5012a2bec8f5.svg";
export { ForwardRef as ReactComponent };